import { COM_TASKS_EN, COM_TASKS_DE } from '../COM_TASKS_TRANSLATIONS'

/*
 * The onboarding View's english translations
 */
export const ONBOARDING_VIEW_EN = {
  yourLicense: 'Your product:',
  selectUpTo: 'Select up to',
  option: '{count} option | {count} options',
  back: 'Back',
  editResponses: 'Edit Responses',
  finalizeSetup: 'Finalize Setup',
  notAnswered: 'Not answered',
  dyn: {
    QUESTIONTITLE: {
      MainInput: 'Main Input',
      TargetAudience: 'Target Audience',
      Platforms: 'Platforms',
      BrandVoice: 'Brand Voice',
      Avoid: 'Avoid',
      MainContentType: 'Main Content Type',
      AdditionalContentTypes: 'Additional Content Types',
      Whatisyourprofessionorrole: 'What is your profession or role?',
      Whatisyourpreferredinputtype: 'What is your preferred input?',
      Whoisyourmaintargetaudience: 'Who is your main target audience?',
      Forwhichsocialplatformsorchannelsshouldwegeneratecaptions:
        'For which social platforms should we generate captions?',
      Inwhichlanguagesshouldthecontentbegenerated:
        'In which languages should the content be generated?',
      WhattonestyleortypeofwritingshouldtheAIabsolutelyavoid:
        'What tone of voice should we absolutely avoid?',
      Whatisyourmaintypeofcontent: 'What is your Main Communication Task?',
      Whatareyouradditionaldesiredoutputformats:
        'What are your additional desired Communication Tasks?',
      Profession: 'Profession',
      WhichnewsroomsLanguageStyledoyouwanttoselect: 'Choose your newsrooms Language Style:'
    },

    QUESTIONOPTION: {
      BlogPosts: 'Blog Posts',
      InternalMemos: 'Internal Memos',
      PressReleases: 'Press Releases',
      ProductDescriptions: 'Product Descriptions',
      CaseStudies: 'Case Studies',
      VideoScripts: 'Video Scripts',
      EMails: 'Emails',
      Consumers: 'Consumers',
      BBCustomers: 'B2B Customer',
      Employees: 'Employees',
      Investors: 'Investors',
      IndustryExperts: 'Industry Experts',
      EditorinChief: 'Editor in Chief',
      Journalist: 'Journalist',
      PRManager: 'PR Manager',
      Marketing: 'Marketing',
      Writer: 'Writer',
      Podcaster: 'Podcaster',
      CLevelExecutive: 'C-Level Executive',
      VideoImageDesign: 'Video/Image Design',
      SingleEntrepreneur: 'Single Entrepreneur',
      Icopypasteeverything: 'I copy paste everything',
      French: 'French',
      Ukrainian: 'Ukrainian',
      Czech: 'Czech',
      Slovakian: 'Slovakian',
      Croatian: 'Croatian',
      Serbian: 'Serbian',
      Slovenian: 'Slovenian',
      Friendly: 'Friendly',
      Innovative: 'Innovative',
      Casual: 'Casual',
      Persuasive: 'Persuasive',
      Authoritative: 'Authoritative',
      Slang: 'Slang',
      OverlyTechnical: 'Overly Technical',
      SalesSpeak: 'SalesSpeak',
      Controversial: 'Controversial',
      Jargon: 'Jargon',
      TwitterX: 'Twitter/X',
      Facebook: 'Facebook',
      Instagram: 'Instagram',
      TikTok: 'TikTok',
      Bluesky: 'Bluesky',
      LinkedIn: 'LinkedIn',
      Professional: 'newsrooms professional',
      Exciting: 'newsrooms exciting',
      Clear: 'newsrooms clear',
      Informal: 'newsrooms informal',

      // Formats
      ...COM_TASKS_EN.dyn.FORMAT
    }
  },

  wereTailoringNewsroomsAiToFitYouPerfectly: "We're tailoring newsrooms to fit you perfectly.",
  giveUsAMoment: 'Give us a moment...',
  letsStart: "Let's start",
  startSlideHeading: "Let's get started and set up the basics",
  startSlideText:
    'This is the moment to customise your experience. You will be presented with a series of questions allowing us to cater perfectly to your needs.',
  completeSlideHeading: 'Almost there!',
  completeSlideText:
    "We now just need to apply the finishing touches. Click below and we'll set everything up for you.",
  completeSlideButton: 'Finish setup',
  saveOnPrice: 'Spare'
}
/*
 * Deutsche Übersetzung für die Onboarding-Ansicht
 */
export const ONBOARDING_VIEW_DE = {
  yourLicense: 'Ihr Produkt:',
  selectUpTo: 'Wählen Sie bis zu',
  option: '{count} Option | {count} Optionen',
  back: 'Zurück',
  editResponses: 'Antworten bearbeiten',
  finalizeSetup: 'Setup abschließen',
  notAnswered: 'Nicht beantwortet',
  dyn: {
    QUESTIONTITLE: {
      MainInput: 'Haupteingabe',
      TargetAudience: 'Zielgruppe',
      Platforms: 'Plattformen',
      BrandVoice: 'Brand-Stimme',
      Avoid: 'Vermeiden',
      MainContentType: 'Haupt-Contenttyp',
      AdditionalContentTypes: 'Weitere Content-Typen',
      Whatisyourprofessionorrole: 'Was ist Ihr Beruf oder Ihre Rolle?',
      Whatisyourpreferredinputtype: 'Welche Eingabe bevorzugen Sie?',
      Whoisyourmaintargetaudience: 'Wer ist Ihre Hauptzielgruppe?',
      Forwhichsocialplatformsorchannelsshouldwegeneratecaptions:
        'Für welche Social-Plattformen sollen Captions generiert werden?',
      Inwhichlanguagesshouldthecontentbegenerated:
        'In welchen Sprachen soll der Content erstellt werden?',
      WhattonestyleortypeofwritingshouldtheAIabsolutelyavoid:
        'Welchen Schreibstil sollen wir auf jeden Fall vermeiden?',
      Whatisyourmaintypeofcontent: 'Was ist Ihre Haupt-Kommunikationsaufgabe?',
      Whatareyouradditionaldesiredoutputformats:
        'Welche weiteren Kommunikationsaufgaben benötigen Sie?',
      Profession: 'Beruf',
      WhichnewsroomsLanguageStyledoyouwanttoselect: 'Wählen Sie Ihren newsrooms Sprachstil:'
    },

    // Format response
    QUESTIONOPTION: {
      BlogPosts: 'Blogposts',
      InternalMemos: 'Interne Memos',
      PressReleases: 'Pressetexte',
      ProductDescriptions: 'Produktbeschreibungen',
      CaseStudies: 'Case Studies',
      VideoScripts: 'Video-Skripte',
      EMails: 'E-Mails',
      Consumers: 'Konsumenten',
      BBCustomers: 'B2B-Kunden',
      Employees: 'Mitarbeiter:innen',
      Investors: 'Investor:innen',
      IndustryExperts: 'Branchenexpert:innen',
      EditorinChief: 'Chefredakteur:in',
      Journalist: 'Journalist:in',
      PRManager: 'PR-Manager:in',
      Marketing: 'Marketing',
      Writer: 'Texter:in',
      Podcaster: 'Podcaster:in',
      CLevelExecutive: 'C-Level-Führungskraft',
      VideoImageDesign: 'Video-/Bildgestaltung',
      SingleEntrepreneur: 'Solo-Selbstständige:r',
      Icopypasteeverything: 'Ich kopiere & füge alles ein',
      French: 'Französisch',
      Ukrainian: 'Ukrainisch',
      Czech: 'Tschechisch',
      Slovakian: 'Slowakisch',
      Croatian: 'Kroatisch',
      Serbian: 'Serbisch',
      Slovenian: 'Slowenisch',
      Friendly: 'Freundlich',
      Innovative: 'Innovativ',
      Casual: 'Locker',
      Persuasive: 'Überzeugend',
      Authoritative: 'Autoritativ',
      Slang: 'Umgangssprache',
      OverlyTechnical: 'Zu technisch',
      SalesSpeak: 'Vertriebssprache',
      Controversial: 'Kontrovers',
      Jargon: 'Fachsprache',
      TwitterX: 'Twitter/X',
      Facebook: 'Facebook',
      Instagram: 'Instagram',
      TikTok: 'TikTok',
      Bluesky: 'Bluesky',
      LinkedIn: 'LinkedIn',
      Professional: 'newsrooms professional',
      Exciting: 'newsrooms exciting',
      Clear: 'newsrooms clear',
      Informal: 'newsrooms informal',

      // FORMAT
      ...COM_TASKS_DE.dyn.FORMAT
    }
  },

  wereTailoringNewsroomsAiToFitYouPerfectly: 'Wir passen newsrooms genau auf Sie an.',
  giveUsAMoment: 'Geben Sie uns einen Moment...',
  letsStart: 'Loslegen',
  startSlideHeading: 'Lassen Sie uns anfangen und die Basics einrichten',
  startSlideText:
    'Das ist der Moment wo wir Ihre Experience personalisieren. Sie werden eine Reihe von Fragen beantworten, damit wir unser Produkt perfekt an Ihre Bedürfnisse anpassen können.',
  completeSlideHeading: 'Gleich fertig!',
  completeSlideText:
    'Jetzt fehlt nur noch der Feinschliff. Klicken Sie auf den Button und wir kümmern uns um den Rest.',
  completeSlideButton: 'Fertigstellen',
  saveOnPrice: 'Spare'
}
